module.exports = __webpack_public_path__ + "media/images/walla-logo-a65343efca80e61bdd9828dd0e98f7df.png";